import type { RentOverview, ValuationOverview as ValuationOverviewSchema } from '@einwert/valuation-api-client'

import { Stack } from '@mui/material'
import { ListCardInfo, MonetaryValue, Percentage, tokens } from 'ComponentLibrary'
import Typography from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

export const ValuationInfoCell = ({ valuation, rent }: { valuation: ValuationOverviewSchema; rent?: RentOverview }) => {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()
    const grossYield = valuation.gross_yield !== undefined ? new Percentage(valuation.gross_yield) : undefined
    const annualRent =
        rent?.summary.total?.gross_rental_income?.total !== undefined
            ? MonetaryValue.fromMonetaryValueDataObject(rent.summary.total.gross_rental_income.total)
            : undefined
    const costs =
        rent?.summary.total?.management_cost?.total !== undefined
            ? MonetaryValue.fromMonetaryValueDataObject(rent.summary.total.management_cost.total)
            : undefined

    if (!annualRent && !costs && !grossYield) {
        return (
            <ListCardInfo
                style={{
                    minWidth: '290px',
                    flexGrow: 1,
                }}
            />
        )
    }

    return (
        <ListCardInfo
            style={{
                minWidth: '290px',
                flexGrow: 1,
                padding: tokens.SizingSpacing075,
                borderRadius: tokens.SizingCornerS,
                backgroundColor: tokens.ColorSurfaceInverseDefault,
                gap: tokens.SizingSpacing025,
                height: '50px',
            }}
        >
            {annualRent && rent && (
                <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                    <Typography variant="textS" color={tokens.ColorTextSubtle}>
                        {tCommon('marketRent')}
                    </Typography>
                    <Typography variant="textS" color={tokens.ColorTextBold}>
                        +{annualRent.format({ withoutDecimals: true, locale })}
                    </Typography>
                </Stack>
            )}
            {grossYield && (
                <Stack direction="row" width="100%" justifyContent="space-between" gap={tokens.SizingSpacing075}>
                    <Typography variant="textS" color={tokens.ColorTextSubtle}>
                        {tCommon('grossYield')}
                    </Typography>
                    <Typography variant="textS" color={tokens.ColorTextBold}>
                        {grossYield.format({ numberOfDigits: 2, locale })}
                    </Typography>
                </Stack>
            )}
        </ListCardInfo>
    )
}
